import { render, staticRenderFns } from "./08OddballWins.vue?vue&type=template&id=c7f132ca&"
import script from "./08OddballWins.vue?vue&type=script&lang=js&"
export * from "./08OddballWins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports